module.exports = __webpack_public_path__ + "img/maternity.3a615fc0.png";